import { render, staticRenderFns } from "./ShopifyTokenManagement.vue?vue&type=template&id=59763039&scoped=true&"
import script from "./ShopifyTokenManagement.vue?vue&type=script&lang=ts&"
export * from "./ShopifyTokenManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59763039",
  null
  
)

export default component.exports